import { ProblemType } from "@/types";
import * as z from "zod";

const problemType: z.ZodType<ProblemType> = z.any();

const ClaimsBaseSchema = z.object({
  customerNote: z
    .string({
      required_error: "required",
      invalid_type_error: "required",
    })
    .min(1, "required"),
  preferredResolution: z.string({
    required_error: "required",
    invalid_type_error: "required",
  }),
  problemTypes: problemType.array().min(1, { message: "required" }),
  attachments: z.array(z.instanceof(File)).optional(),
});

export const ClaimsSchema = ClaimsBaseSchema;
export type ClaimsFormInput = z.infer<typeof ClaimsSchema>;
